import { getElement, h, Host, } from "@stencil/core";
import { delegateFocus, trapFocus } from "@eventstore-ui/utils";
/** @internal */
export class Popper {
    constructor() {
        this.onClickBackdrop = () => {
            this.requestClose.emit();
        };
        this.backdrop = false;
        this.trapFocus = false;
    }
    async loaded() {
        await this.loadedPromise;
        return true;
    }
    componentWillLoad() {
        this.loadedPromise = new Promise((resolve) => {
            this.hasLoaded = resolve;
        });
    }
    componentDidLoad() {
        this.hasLoaded();
        if (!this.trapFocus)
            return;
        delegateFocus(getElement(this));
    }
    connectedCallback() {
        if (!this.trapFocus)
            return;
        this.releaseFocus = trapFocus(getElement(this));
    }
    disconnectedCallback() {
        this.releaseFocus?.();
    }
    onEscape(e) {
        if (e.key !== 'Escape')
            return;
        this.requestClose.emit();
    }
    render() {
        return (h(Host, { key: 'f8e25f04b9848c0b60e680dc92b9969141b1ad0a' }, this.backdrop && (h("div", { key: 'f44436f0ec92ce5b15bd812301666135a6d57299', onClick: this.onClickBackdrop, class: 'backdrop' })), h("slot", { key: '8c28232ef1cdb3554e2ef7258fba676b17ac4300' })));
    }
    static get is() { return "es-popper"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-popper.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-popper.css"]
        };
    }
    static get properties() {
        return {
            "backdrop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "backdrop",
                "reflect": false,
                "defaultValue": "false"
            },
            "trapFocus": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "trap-focus",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "requestClose",
                "name": "requestClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "loaded": {
                "complexType": {
                    "signature": "() => Promise<boolean>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<boolean>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get listeners() {
        return [{
                "name": "keyup",
                "method": "onEscape",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=es-popper.js.map
